export const adminInputClass =
  "w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400";

export const adminActionButtonClass =
  "flex items-center gap-1.5 rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-600";

export const adminCancelButtonClass =
  "flex-1 rounded-lg border border-gray-200 py-2 text-sm text-gray-600 hover:bg-gray-50";

export const adminPrimaryButtonClass =
  "flex-1 rounded-lg bg-blue-500 py-2 text-sm font-medium text-white hover:bg-blue-600 disabled:opacity-50";

export const adminDangerButtonClass =
  "flex-1 rounded-lg bg-red-500 py-2 text-sm font-medium text-white hover:bg-red-600 disabled:opacity-50";
